// extracted by mini-css-extract-plugin
export var actionText = "_n3-4";
export var container = "_n3-0";
export var leftSection = "_n3-1";
export var rightSection = "_n3-2";
export var settingsButton = "_n3-6";
export var settingsIcon = "_n3-7";
export var shortcut = "_n3-5";
export var shortcutGroup = "_n3-3";